export function setSurveysLoading (state, loading = false) {
  state.surveysLoading = loading
}

export function setSurveys (state, surveys) {
  state.surveys = surveys.data
  state.surveysCurrentPage = surveys.current_page
  state.surveysLastPage = surveys.last_page
  state.surveysPerPage = surveys.per_page
  state.surveysTotal = surveys.total
  state.surveysActiveTotal = surveys.total_active
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}

export function resetViews (state, survey_id) {
  const k = state.surveys.map(function(e) { return e._id; }).indexOf(survey_id)
  const el = state.surveys[k]
  el.seen.length = 0

  state.surveys.splice(k, 1, el)
}
